import { Fragment } from "react"
import { parseISO, formatDistanceToNow } from "date-fns"
import {
  Text,
  Image,
  Flex,
  Box,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react"

import {
  COLORS,
  DATE_FORMAT_EXPANDABLE_ROW,
} from "../../../constants/constants"

import flightImages from "../../../flightImages"
import airplane from "../../../img/airplane.svg"
import { formatUTCDate } from "../../../helpers/functions"

const parseDate = (dateStr) => {
  return parseISO(dateStr)
}

const ExpandableRow = ({ flight }) => {
  const formatClassDesignation = (designation) => {
    return designation === "PremiumEconomy" ? "Premium Economy" : designation
  }

  return (
    <Box>
      {flight.details.map((detail, index, details) => {
        let airlineImageAlt = ""

        if (detail.aircraft_details.startsWith("EK")) {
          airlineImageAlt = `book_emirates_reward_flights_to_${detail.to_airport}`
        } else if (detail.aircraft_details.startsWith("UA")) {
          airlineImageAlt = `book_united_airlines_reward_flights_to_${detail.to_airport}`
        } else {
          airlineImageAlt = `book_${detail.from_airport}_reward_flights_to_${detail.to_airport}`
        }

        const lastSeen = formatDistanceToNow(parseDate(flight.timestamp), {
          addSuffix: true,
        })

        const lastSeenText =
          lastSeen === "less than a minute ago"
            ? "around 1 minute ago"
            : lastSeen

        const shouldIncludeAbout =
          !lastSeenText.includes("about") &&
          lastSeenText !== "around 1 minute ago"

        const planeImage =
          details.length >= 3
            ? flightImages("group_3_plus")
            : flightImages(detail.aircraft_details.slice(0, 2))

        return (
          <Fragment key={index}>
            <Flex my={6} fontSize="sm" fontWeight="semibold">
              <Flex alignItems="center" gap="10px" w="36px">
                <Image
                  width="100%"
                  src={planeImage}
                  margin="0 auto"
                  alt={airlineImageAlt}
                />

                {/* <Box
                  height={84}
                  position="relative"
                  borderLeft={"1px solid #B6BAD1"}
                  mr={6}
                  _before={{
                    content: '""',
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    border: "1px solid #B6BAD1",
                    position: "absolute",
                    top: "-13px",
                    left: "-7px",
                  }}
                  _after={{
                    content: '""',
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    border: "1px solid #B6BAD1",
                    position: "absolute",
                    bottom: "-13px",
                    left: "-7px",
                  }}
                /> */}
              </Flex>

              <Image
                src={airplane}
                width="24px"
                height="108px"
                alt={`reward_flight_duration_between_${detail.from_airport}_and_${detail.to_airport}`}
                alignSelf="center"
                mr="2px"
              />

              <Box w={"45%"} fontSize="12px" mr={1}>
                <Text color={COLORS.secondary}>
                  {formatUTCDate(
                    detail.departure_date,
                    DATE_FORMAT_EXPANDABLE_ROW
                  )}
                </Text>
                <Text>{detail.from_airport}</Text>

                <Flex alignItems={"center"} gap={3}>
                  <Text color={COLORS.secondary} my={5} fontSize={"xs"}>
                    {detail.flight_duration}
                  </Text>

                  <Text color={COLORS.secondary}>
                    {detail.aircraft_details?.split("(")[0] || ""}
                    {detail.aircraft_details && detail.equipment && " | "}
                    {detail.equipment || ""}
                  </Text>
                </Flex>

                <Text color={COLORS.secondary}>
                  {formatUTCDate(
                    detail.arrival_date,
                    DATE_FORMAT_EXPANDABLE_ROW
                  )}
                </Text>
                <Text>{detail.to_airport}</Text>
              </Box>

              <Flex
                flexDirection={"column"}
                w={"45%"}
                fontSize={"12px"}
                gap={1}
              >
                <Flex flexDirection={"column"}>
                  <Text color={COLORS.secondary}>Seats:</Text>

                  <UnorderedList ml={6}>
                    {flight.class_details.map((classDetail, idx) => (
                      <ListItem key={idx} color={COLORS.secondary}>
                        {formatClassDesignation(classDetail.designated_class)}{" "}
                        Class {classDetail.remaining_seats}
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Flex>

                <Text color={COLORS.secondary}>
                  Last seen: {shouldIncludeAbout ? "about " : ""}
                  {lastSeenText}
                </Text>
              </Flex>
            </Flex>
            {index < details.length - 1 && (
              <Box
                ml="60px"
                py={2}
                borderTop="1px solid #D4D4D9;"
                borderBottom="1px solid #D4D4D9;"
                fontWeight="semibold"
                fontSize={"12px"}
              >
                <Text>
                  Layover: {detail.to_airport} {detail.transition_time}
                </Text>
              </Box>
            )}
          </Fragment>
        )
      })}
    </Box>
  )
}

export default ExpandableRow
